import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import { OriginConstant } from '../constants';

/**
 * Derive targetOrigin from iframe.src
 */
export function getIframeTargetOrigin(iframe) {
  if (!iframe.src) {
    return OriginConstant.ANY;
  }
  try {
    return new URL(iframe.src).origin;
  } catch (e) {
    return OriginConstant.ANY;
  }
}